import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import * as actions from './redux/actions';
import ListEvent from '../event/List';
import Footer from '../others/Footer';
import Login from '../authentification/LogIn';
import { url } from '../../helper/image';
import { Carousel, Row, Col, Modal, Button } from 'antd';

export class Home extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { visible: false }

  showModal = () => {
    this.setState({
      visible: true,
    });
  }

  componentWillReceiveProps(props) {
    if (props.is.auth) {
      this.setState({ visible: false })
    }
  }

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  }

  render() {

    return (
      <div className="home-home">
        {
          this.props.is.auth ?
            <div className="btn-compte">
              <Link to={ this.props.is.admin ? "/admin/events" : "/user/profil" }>
                <div className="i-avatar">
                  <img src={url("logo/icon-small.png")}></img>
                </div>
              </Link>
            </div>
            :
            <Button className="btn-compte ui-btn" icon="login" onClick={this.showModal}>Connexion</Button>
        }
        <Modal
          className="modal-event"
          visible={this.state.visible}
          onCancel={this.handleCancel}
        >
          <div className="content-form">
            <Login />
          </div>
        </Modal>
        <div className="slider-text" span={16}>
          <Col >
            <h2> { this.props.home.config.title } </h2>
          </Col>
        </div>
        <Carousel className="home-carousel" effect="fade" className="slider" autoplay>
          <div>
            <img src={url("slider_0.jpg")}></img>
          </div>
          <div>
            <img src={url("slider_5.jpg")}></img>
          </div>
        </Carousel>
        <div className="logo">
          <img src={url("logo/logo-ynov-bx.svg")}></img>
        </div>
        <Row>
          <Row>
            <ListEvent loginModal={this.showModal} id={this.props.match.params.id}/>
          </Row>

        </Row>
        <Footer/>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Home);



// WEBPACK FOOTER //
// ./src/features/home/Home.js